import { ComponentProps } from 'react';
import { cn } from '../../../utils/className';

interface MobilePaginationProps extends ComponentProps<'div'> {
  currentPage: number; // 1-based
  totalPages: number;
  totalCount?: number;
  rowsPerPage?: number;
  onPageChange?: (page: number) => void;
  isLoading?: boolean;
}

export function MobilePagination({
  currentPage,
  totalPages,
  totalCount,
  rowsPerPage,
  onPageChange,
  isLoading = false,
  className,
  ...props
}: MobilePaginationProps) {
  const isFirstPage = currentPage <= 1;
  const isLastPage = currentPage >= totalPages;
  const disabled = isLoading || totalPages === 0;

  return (
    <div
      className={cn(
        `bg-surface-primary-support flex w-full items-center justify-between
        gap-3 px-4 py-3`,
        className
      )}
      {...props}
    >
      <div className='text-secondary flex flex-col'>
        <span className='size-p2'>
          Page {totalPages === 0 ? '-' : currentPage} of {totalPages || '-'}
        </span>
        {typeof totalCount === 'number' && (
          <span className='size-p3 text-tertiary'>
            {totalCount} total{rowsPerPage ? ` · ${rowsPerPage}/page` : ''}
          </span>
        )}
      </div>

      <div className='flex items-center gap-2'>
        <button
          type='button'
          onClick={() => onPageChange?.(Math.max(1, currentPage - 1))}
          disabled={disabled || isFirstPage}
          className='border-border-primary text-primary disabled:text-disabled
            flex h-10 min-w-16 items-center justify-center rounded border
            bg-white px-3 py-2 text-sm font-medium disabled:cursor-not-allowed
            disabled:opacity-60'
        >
          Prev
        </button>
        <button
          type='button'
          onClick={() => onPageChange?.(Math.min(totalPages, currentPage + 1))}
          disabled={disabled || isLastPage}
          className='border-border-primary text-primary disabled:text-disabled
            flex h-10 min-w-16 items-center justify-center rounded border
            bg-white px-3 py-2 text-sm font-medium disabled:cursor-not-allowed
            disabled:opacity-60'
        >
          Next
        </button>
      </div>
    </div>
  );
}
